import { useContext } from 'react';

import AppContext from 'App/AppContext';
import { IPSeparator, IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import CheckListProgress from 'components/Checklist/ChecklistProgress';
import { KeyValueTags } from 'components/Tags/KeyValueTag';
import {
  globalFontBoldWeight,
  globalStackItemStylesCard,
  globalStackStylesCard,
  globalStackTokensGapCard,
  globalStackTokensGapSmall,
  globalTextStylesCard,
} from 'globalStyles';
import { toLocaleDateShortNoYear } from 'utils/datetime';
import { ICardTaskProps } from './KanbanCard';

const KanbanCardTaskGeneric = (props: ICardTaskProps) => {
  const appContext = useContext(AppContext);

  return (
    <div
      onClick={() => {
        if (props.onClick) props.onClick(props.task);
      }}
    >
      <IPStack styles={globalStackStylesCard} tokens={globalStackTokensGapCard}>
        <IPStack.Item styles={globalStackItemStylesCard}>
          <IPText
            block
            styles={{
              root: { fontWeight: globalFontBoldWeight, paddingTop: 0, paddingBottom: 0, wordBreak: 'break-word' },
            }}
          >
            {props.task.name}
          </IPText>
        </IPStack.Item>
        <IPStack.Item>
          <CheckListProgress
            compact
            totalChecks={props.task.checkList.items.length}
            successChecks={props.task.checkList.getSuccessfulCount()}
            failedChecks={props.task.checkList.getFailedCount()}
          ></CheckListProgress>
        </IPStack.Item>
        {props.task.tagIds && props.task.tagIds.length > 0 && (
          <IPStack.Item styles={globalStackItemStylesCard}>
            <IPSeparator styles={{ root: { height: 1 } }}></IPSeparator>
            <KeyValueTags
              compact
              tagWidth={150}
              tags={appContext.globalDataCache.tags.getItemsForId(props.task.tagIds)}
            />
          </IPStack.Item>
        )}
        <IPStack.Item styles={globalStackItemStylesCard}>
          <IPSeparator styles={{ root: { height: 1 } }}></IPSeparator>
          <IPStack horizontal tokens={globalStackTokensGapSmall} verticalAlign="center">
            <IPStack.Item>
              <IPText block variant="small" styles={globalTextStylesCard}>
                {toLocaleDateShortNoYear(props.task.startDateTime)}
              </IPText>
            </IPStack.Item>
          </IPStack>
        </IPStack.Item>
      </IPStack>
    </div>
  );
};

export default KanbanCardTaskGeneric;
